/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";

export const getFABApis = stores => {
  function registerFAB(verbId, opts = {}) {
    stores.FABStore.registerFABVerbId(verbId, opts);
    return true;
  }

  function setVisibility(value) {
    stores.FABStore.setFABVisibility(value);
    return true;
  }

  return {
    registerFAB,
    setVisibility
  };
};

export const registerFABApis = stores => {
  apiFactory.registerApi(publicApiNames.FAB, clientName => getFABApis(stores), true);
};
